import React from 'react'
import { MapMobileErrorState } from '../../components/mobile'
import ReportMapCanvas from './ReportMapCanvas'
import {
  getActivityMapMobileCaptureErrorMessage,
  getActivityMapMobileErrorMessages
} from './helpers/mobileMapErrorCopy'

const ShowMapModalContent = (props) => {
  const isMobileView = Boolean(props.isMobileView)
  const reportLatitude = Number.parseFloat(props.latitude) || 0
  const reportLongitude = Number.parseFloat(props.longitude) || 0
  const clientLatitude = Number.parseFloat(props.clientLatitude) || 0
  const clientLongitude = Number.parseFloat(props.clientLongitude) || 0
  const geofenceRadius =
    Number.parseInt(
      props.recordedGeoMaxDistanceInMeter ||
        props.salesmanVisitData?.recorded_geo_max_distance_in_meter,
      10
    ) || 100

  const reportCoordinatesAreEmpty = reportLatitude === 0 && reportLongitude === 0
  const hasClientCoordinates = clientLatitude !== 0 && clientLongitude !== 0

  const locationCaptureErrorMessage =
    props.hasAllowedLocation === false
      ? 'Hubo un error al capturar la ubicacion del equipo. El usuario no otorgo permisos de ubicacion.'
      : 'Hubo un error al capturar la ubicacion del equipo.'

  const renderErrorState = (messages) => {
    const normalizedMessages = Array.isArray(messages)
      ? messages.filter(Boolean)
      : [messages].filter(Boolean)

    if (!isMobileView) {
      return (
        <div className="map-modal-error">
          {normalizedMessages.map((message, index) => (
            <div key={`map-error-${index}`} className="map-error-label">
              {message}
            </div>
          ))}
        </div>
      )
    }

    return <MapMobileErrorState messages={normalizedMessages} />
  }

  const hasReportCoordinates =
    props.latitude !== null && props.longitude !== null && !reportCoordinatesAreEmpty

  return (
    <>
      {hasReportCoordinates && (
        <ReportMapCanvas
          modern={props.modern}
          geofenceInfo={props.geofenceInfo}
          geofenceStatus={props.geofenceStatus}
          isMobileView={isMobileView}
          defaultCenter={{ lat: reportLatitude, lng: reportLongitude }}
          defaultZoom={16}
          maxZoom={props.modern ? 21 : isMobileView ? 19 : 18}
          singlePointZoom={isMobileView ? 17 : 16}
          fitBoundsPadding={isMobileView ? 24 : 84}
          closePlacesMinZoom={isMobileView ? 18 : null}
          geofence={
            hasClientCoordinates
              ? { lat: clientLatitude, lng: clientLongitude, radius: geofenceRadius }
              : null
          }
          markers={[
            {
              lat: reportLatitude,
              lng: reportLongitude,
              name: 'Captura de actividad',
              isReport: false,
              color: 'red'
            },
            ...(hasClientCoordinates
              ? [
                  {
                    lat: clientLatitude,
                    lng: clientLongitude,
                    name: 'Ubicación del cliente',
                    isReport: true,
                    color: 'green'
                  }
                ]
              : [])
          ]}
        />
      )}
      {props.latitude !== null &&
        props.longitude !== null &&
        reportCoordinatesAreEmpty &&
        renderErrorState(
          isMobileView
            ? getActivityMapMobileCaptureErrorMessage(props.hasAllowedLocation)
            : locationCaptureErrorMessage
        )}
      {props.errorCoordinatesCode === 1 &&
        props.latitude === null &&
        props.longitude === null &&
        renderErrorState(
          isMobileView
            ? getActivityMapMobileErrorMessages({
                errorCoordinatesCode: props.errorCoordinatesCode,
                hasAllowedLocation: props.hasAllowedLocation
              })
            : [
                'La geocoordenada no ha sido capturada (1).',
                'El usuario ha denegado el acceso a la ubicación del equipo. Debe solicitar al usuario que habilite el acceso.'
              ]
        )}
      {props.errorCoordinatesCode === 2 &&
        props.latitude === null &&
        props.longitude === null &&
        renderErrorState(
          isMobileView
            ? getActivityMapMobileErrorMessages({
                errorCoordinatesCode: props.errorCoordinatesCode,
                hasAllowedLocation: props.hasAllowedLocation
              })
            : [
                'La geocoordenada no ha sido capturada (2).',
                'Geocoordenadas no disponible. Hubo un fallo en uno, o mas, de los proveedores usados para la captura de posición.'
              ]
        )}
      {props.errorCoordinatesCode === 0 &&
        props.latitude === null &&
        props.longitude === null &&
        renderErrorState(
          isMobileView
            ? getActivityMapMobileErrorMessages({
                errorCoordinatesCode: props.errorCoordinatesCode,
                hasAllowedLocation: props.hasAllowedLocation
              })
            : [
                'La geocoordenada no ha sido capturada (0).',
                'Hubo un error en el servicio de captura.'
              ]
        )}
      {props.errorCoordinatesCode === 3 &&
        props.latitude === null &&
        props.longitude === null &&
        renderErrorState(
          isMobileView
            ? getActivityMapMobileErrorMessages({
                errorCoordinatesCode: props.errorCoordinatesCode,
                hasAllowedLocation: props.hasAllowedLocation
              })
            : [
                'La geocoordenada no ha sido capturada (3).',
                'Hubo un error en el servicio de captura.'
              ]
        )}
      {props.errorCoordinatesCode === 4 &&
        props.latitude === null &&
        props.longitude === null &&
        renderErrorState(
          isMobileView
            ? getActivityMapMobileErrorMessages({
                errorCoordinatesCode: props.errorCoordinatesCode,
                hasAllowedLocation: props.hasAllowedLocation
              })
            : [
                'La geocoordenada no ha sido capturada (4).',
                'Hubo un error en el servicio de captura.'
              ]
        )}
      {props.latitude === null &&
        props.longitude === null &&
        (props.errorCoordinatesCode === null || props.errorCoordinatesCode === undefined) &&
        renderErrorState(
          isMobileView
            ? getActivityMapMobileErrorMessages({
                errorCoordinatesCode: props.errorCoordinatesCode,
                hasAllowedLocation: props.hasAllowedLocation
              })
            : props.hasAllowedLocation === null
              ? 'No se capturó la ubicación de la actividad.'
              : props.hasAllowedLocation === true
                ? 'Hubo un error al enviar ubicación de la actividad. Contacte a soporte@ubiqua.me para verificar esta información.'
                : locationCaptureErrorMessage
        )}
    </>
  )
}

export default ShowMapModalContent
